import React from 'react'
import styled from 'styled-components'
import 'styles/reset.css'
import { universalLink } from 'constants/mobile-app'
import { trackGetApp } from 'tracking/pixel'
import { ButtonGradientFilled } from './Button'

const ButtonStyled = styled(ButtonGradientFilled)`
  position: relative;
  border-radius: 100px;
  width: 138px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`

const Button = () => (
  <ButtonStyled
    href={universalLink}
    aria-label="Get FlipFit App"
    as="a"
    onClick={trackGetApp}
  >
    <span>Get started</span>
  </ButtonStyled>
)

export default Button
